module.exports = __webpack_public_path__ + "static/media/ENData Logo.d846d234.png";